import gql from 'graphql-tag'

export const APPLICATION_DELETE_MUTATION = gql`
    mutation applicationDelete(
        $id: ID!
    ) {
        applicationDelete(
            id: $id
        ) {
            status
        }
    }
`
